import {Fragment, useState} from "react";
import {IconButton} from "@mui/material";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {ConfirmDialog} from "@dvrt/graphql-widgets";
import {useDispatch} from "react-redux";
import {showNotification} from "../../../actions";
import {defineMessage} from "react-intl";
import {useDeleteSpeedDialMutation} from "./queries.generated";
import {CONFIRM_MESSAGES} from "@/utils/translations";

type Props = {
    id: number;
    onSuccess: () => void;
    name: string;
    disabled: boolean;
};

export default ({id, name, onSuccess, disabled}: Props) => {
    const [isDialogOpen, setDialogOpen] = useState(false);
    const dispatch = useDispatch();
    const [mutation] = useDeleteSpeedDialMutation();

    function mutate() {
        mutation({variables: {id}})
            .then((response) => {
                if (!response.data.deleteSpeedDial.length) {
                    dispatch(
                        showNotification(
                            defineMessage({id: "speed_dial_deleted", defaultMessage: "Speed dial deleted"}),
                            "success",
                        ),
                    );
                    setDialogOpen(false);
                    onSuccess();
                } else {
                    dispatch(
                        showNotification(
                            defineMessage({id: "unexpected_error", defaultMessage: "Unexpected error"}),
                            "error",
                        ),
                    );
                }
            })
            .catch(() => {
                dispatch(
                    showNotification(
                        defineMessage({id: "unexpected_error", defaultMessage: "Unexpected error"}),
                        "error",
                    ),
                );
            });
    }

    return (
        <Fragment>
            <IconButton color="secondary" onClick={() => setDialogOpen(true)} size="small" disabled={disabled}>
                <FontAwesomeIcon icon="trash" />
            </IconButton>
            <ConfirmDialog
                isOpen={isDialogOpen}
                close={() => setDialogOpen(false)}
                onConfirm={mutate}
                message={CONFIRM_MESSAGES.delete_speed_dial}
                messageVars={{name}}
                buttonIdPrefix="delete-speed-dial"
            />
        </Fragment>
    );
};
